const REFERRAL_STORAGE_KEY = "sgpp-referral-first-click";
const REFERRAL_WINDOW_MS = 60 * 24 * 60 * 60 * 1000;

export const normalizeReferralCode = (value) =>
  String(value || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9-_]/g, "")
    .replace(/_/g, "-")
    .slice(0, 48);

const canUseStorage = () => typeof window !== "undefined" && Boolean(window.localStorage);

export const getStoredReferralAttribution = () => {
  if (!canUseStorage()) return null;
  try {
    const raw = window.localStorage.getItem(REFERRAL_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.code || !parsed?.expiresAt) return null;
    if (new Date(parsed.expiresAt).getTime() <= Date.now()) {
      window.localStorage.removeItem(REFERRAL_STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const getStoredReferralCode = () => getStoredReferralAttribution()?.code || null;

export const getReferralDisplayState = (queryCode) => {
  const stored = getStoredReferralAttribution();
  const incomingCode = normalizeReferralCode(queryCode);
  const activeCode = stored?.code || incomingCode || null;

  return {
    activeCode,
    incomingCode: incomingCode || null,
    hasStoredAttribution: Boolean(stored?.code),
    hasIncomingQuery: Boolean(incomingCode),
    isStoredWithoutQuery: Boolean(stored?.code && !incomingCode),
    isLockedToDifferentCode: Boolean(stored?.code && incomingCode && stored.code !== incomingCode),
  };
};

export const persistReferralAttribution = (value) => {
  const normalizedCode = normalizeReferralCode(value);
  if (!normalizedCode || !canUseStorage()) return null;
  const existing = getStoredReferralAttribution();
  if (existing?.code) {
    return existing;
  }
  const capturedAt = new Date().toISOString();
  const expiresAt = new Date(Date.now() + REFERRAL_WINDOW_MS).toISOString();
  const nextValue = { code: normalizedCode, capturedAt, expiresAt };
  window.localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(nextValue));
  return nextValue;
};